import { render, staticRenderFns } from "./u-button.vue?vue&type=template&id=47463a1f&scoped=true&"
import script from "./u-button.vue?vue&type=script&lang=js&"
export * from "./u-button.vue?vue&type=script&lang=js&"
import style0 from "./u-button.vue?vue&type=style&index=0&id=47463a1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47463a1f",
  null
  
)

export default component.exports